<script>

  export default {
    data() {
      return {
        show: false
      }
    },
    computed: {
      toast() {
        return this.$store.state.ui.toast
      },
    },
    watch: {
      toast: function() {
        if (this.toast && this.toast.message) {
          this.show = false
          setTimeout(() => this.show = true, 20)
        }
      }
    }
  }

</script>


<template>

  <div class="text-center">
    <v-snackbar
      :color="toast.color"
      v-model="show"
      :timeout="toast.delay"
      transition="fade-transition"
      top
      center
      multi-line
      dark
    >
      <div class="text-center">{{toast.message}}</div>
    </v-snackbar>
  </div>

</template>

<style lang="scss" scoped>

</style>
